// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rF7F","left":"styles_left__3aRfB"};